import {
  useGetMasterDistrict,
  useGetMasterProvince,
  useGetTransportType,
  useMasterBoxSize,
  useMasterTransport,
} from "hooks/useMasterData";
import {
  Button,
  Form,
  FormInstance,
  Input,
  Modal,
  Select,
  Space,
  TimePicker,
  Typography,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  DeliveryPointData,
  GetOrderDetailData,
  MasterBoxData,
  MasterTransport,
  ParkingLists,
  Transportbuslist,
} from "services/interface";
import { useConfirmOrderTransport } from "hooks/useOrders";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import ModalTransport from "./ModalTransport";
import { useAppSelector } from "store";
import {
  useCreateDeliveryPoint,
  useCreateParking,
  useDeliveryPoint,
  useGetParkingList,
} from "hooks/useShipping";
import DescriptionForm from "components/ManageTransportaition/ModalCreateDeliveryPoint/DescriptionForm";
import styled from "@emotion/styled";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

dayjs.extend(customParseFormat);

interface TransportSeleectProps {
  formTransport: FormInstance<any>;
  parkingSelect?: ParkingLists | undefined;
}

const { Option } = Select;

const TransportSeleect = ({
  formTransport,
  parkingSelect,
}: TransportSeleectProps) => {
  const factoryId = useAppSelector(
    (state) => state.auth.profile?.user?.role?.ref_id
  );

  const [masterTransport, setMasterTransport] = useState<MasterTransport[]>([]);
  const [selectTransport, setSelectTransport] = useState<MasterTransport>();

  const [provinceIdAddress, setProvinceIdAddress] = useState<number>(0);
  const [districtIdAddress, setDistrictIdAddress] = useState<number>(0);

  const [provinceIdstart, setProvinceIdstart] = useState<number>(0);
  const [provinceIdend, setProvinceIdend] = useState<number>(0);

  const [formModal] = Form.useForm();

  const [showParking, setShowParking] = useState<boolean>(false);

  const { mutate: CreateParking } = useCreateDeliveryPoint();
  const { mutate: confirmTransport } = useConfirmOrderTransport();
  const { mutate: getDeliveryPoint } = useDeliveryPoint();
  const { data: masterTransportType } = useGetTransportType();

  const [deliveryPointList, setDeliveryPointList] = useState<
    DeliveryPointData[]
  >([]);

  const [selectParkingBefore, setSelectParkingBefore] = useState<
    DeliveryPointData | undefined
  >();

  const [masterBoxSizeRemain, setMasterBoxSizeRemain] = useState<
    MasterBoxData[]
  >([]);

  const [search, setSearch] = useState<string>("");

  const { data, isLoading, refetch } = useMasterTransport({
    search: search,
  });

  const { data: masterProviceData } = useGetMasterProvince();

  const { data: masterDistrictDataAddress } =
    useGetMasterDistrict(provinceIdAddress);

  useEffect(() => {
    if (data) {
      setMasterTransport(data.data.master_data);
    }
  }, [data]);

  useEffect(() => {
    formTransport.resetFields();
  }, [formTransport]);

  const [childrenParking, setChildrenParking] = useState<React.ReactNode[]>([]);

  //const { mutate: ParkingById, } = useGetParkingList();

  const onCloseModal = () => {
    formModal.resetFields();
    setShowParking(false);
  };

  const getTimeList = (times: string | null) => {
    const time = times?.replace("[", "").replace("]", "").split(",");
    console.log(time);
    return time;
  };

  // useEffect(() => {
  //   formTransport.setFieldsValue({
  //     timeList: [{ time: undefined }],
  //   });
  // }, [formTransport]);

  useEffect(() => {
    if (parkingSelect) {
      setProvinceIdAddress(parkingSelect.province_id);
      setDistrictIdAddress(parkingSelect.district_id);

      formTransport.setFields([
        {
          name: ["province_address_id"],
          value: parkingSelect.province_id,
        },
        {
          name: ["district_address_id"],
          value: parkingSelect.district_id,
        },
        {
          name: ["parking_id"],
          value: parkingSelect.parking_id,
        },
        {
          name: ["delivery_name"],
          value: parkingSelect.parking_name,
        },
        {
          name: ["timeList"],
          value: getTimeList(parkingSelect.times)?.map((item) => ({
            time: dayjs(item, "HH:mm"),
          })),
        },
        {
          name: ["province_name_th"],
          value: parkingSelect.province_name_th,
        },
        {
          name: ["district_name_th"],
          value: parkingSelect.district_name_th,
        },
      ]);
    }
  }, [parkingSelect]);

  useEffect(() => {
    if (selectParkingBefore) {
      setProvinceIdAddress(selectParkingBefore.province_id);
      setDistrictIdAddress(selectParkingBefore.district_id);

      let province_name_th = masterProviceData?.find(
        (item) => item.id === selectParkingBefore.province_id
      )?.name_th;

      let district_name_th = masterDistrictDataAddress?.find(
        (item) => item.id === selectParkingBefore.district_id
      )?.name_th;

      formTransport.setFields([
        {
          name: ["province_address_id"],
          value: selectParkingBefore.province_id,
        },
        {
          name: ["district_address_id"],
          value: selectParkingBefore.district_id,
        },
        {
          name: ["parking_id"],
          value: selectParkingBefore.id,
        },
        {
          name: ["delivery_name"],
          value: selectParkingBefore.delivery_point,
        },
        {
          name: ["province_name_th"],
          value: province_name_th,
        },
        {
          name: ["district_name_th"],
          value: district_name_th,
        },
        // {
        //   name: ["timeList"],
        //   value: getTimeList(selectParkingBefore.times)?.map((item) => ({
        //     time: dayjs(item, "HH:mm"),
        //   })),
        // },
      ]);
    }
  }, [selectParkingBefore, masterProviceData, masterDistrictDataAddress]);

  const childrenTransport: React.ReactNode[] = [];
  masterTransport?.map((item) => {
    return childrenTransport.push(
      <Option key={item.id} value={item.id}>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 2 }}>
            {`${item.name}  ${item.province_name_start} - ${item.province_name_end}
         (รอบ ${item.time_start} - ${item.time_end} น.)`}
          </div>
        </div>
      </Option>
    );
  });

  const childrenTransportType: React.ReactNode[] = [];
  masterTransportType?.map((item) => {
    return childrenTransportType.push(
      <Option key={item.key} value={item.key}>
        {item.name}
      </Option>
    );
  });

  const childrenProviceStart: React.ReactNode[] = [];
  masterProviceData?.map((item) => {
    return childrenProviceStart.push(
      <Option key={item.id} value={item.id} name={item.name_th}>
        {item.name_th}
      </Option>
    );
  });

  const childrenProviceAddress: React.ReactNode[] = [];
  masterDistrictDataAddress?.map((item) => {
    return childrenProviceAddress.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  const childrenProviceEnd: React.ReactNode[] = [];
  masterProviceData?.map((item) => {
    return childrenProviceEnd.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  const filterOption = (input: string, option: any) =>
    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

  useEffect(() => {
    if (selectTransport) {
      setProvinceIdstart(selectTransport.province_start_id);
      setProvinceIdend(selectTransport.province_end_id);

      formTransport.setFieldsValue({
        transport_name: selectTransport.name,
        province_start_id: selectTransport.province_start_id,
        district_start_id: selectTransport.district_start_id,
        province_end_id: selectTransport.province_end_id,
        district_end_id: selectTransport.district_end_id,
        station_start: selectTransport.station_start,
        station_end: selectTransport.station_end,
        type: selectTransport.type,
        license_plate: selectTransport.license_plate,
        car_no: selectTransport.car_no,
        timeStart: selectTransport.time_start
          ? dayjs(selectTransport.time_start, "HH:mm")
          : null,
        timeEnd: selectTransport.time_end
          ? dayjs(selectTransport.time_end, "HH:mm")
          : null,
      });
    }
  }, [formTransport, selectTransport]);

  useEffect(() => {
    setProvinceIdstart(0);
    setProvinceIdend(0);

    getDeliveryPoint(
      {
        district_id: 0,
        province_id: 0,
        //factory_id: factoryId || "",
      },
      {
        onSuccess: (res) => {
          if (res.status === "success") {
            // message.success("สร้างสำเร็จ");
            console.log(res);

            setDeliveryPointList(res.data.data);

            const newChildrenTransport = res.data.data.map(
              (item: DeliveryPointData) => (
                <Option
                  key={item.id}
                  value={item.id}
                  name={item.delivery_point}
                >
                  {item.delivery_point}
                </Option>
              )
            );
            setChildrenParking(newChildrenTransport);
          } else {
            message.error(`สร้างไม่สำเร็จ: ${res.error_message}`);
          }
        },
        onError: (error) => {
          message.error(`สร้างไม่สำเร็จ: ${error.message}`);
        },
      }
    );
  }, []);

  useEffect(() => {
    getDeliveryPoint(
      {
        district_id: districtIdAddress,
        province_id: provinceIdAddress,
        //  factory_id: factoryId || "",
      },
      {
        onSuccess: (res) => {
          if (res.status === "success") {
            //message.success("สร้างสำเร็จ");

            setDeliveryPointList(res.data.data);
            const newChildrenTransport = res.data.data.map(
              (item: DeliveryPointData) => (
                <Option key={item.id} value={item.id}>
                  {item.delivery_point}
                </Option>
              )
            );
            setChildrenParking(newChildrenTransport);
          } else {
            message.error(`สร้างไม่สำเร็จ: ${res.error_message}`);
          }
        },
        onError: (error) => {
          message.error(`สร้างไม่สำเร็จ: ${error.message}`);
        },
      }
    );
  }, [districtIdAddress, getDeliveryPoint, provinceIdAddress, showParking, search]);

  const onFinishModal = (values: any) => {
    CreateParking(
      {
        factory_id: factoryId || "",
        name: values.name,
        district_id: districtIdAddress,
        province_id: provinceIdAddress,
      },
      {
        onSuccess: (res) => {
          if (res.status === "success") {
            message.success("สร้างสำเร็จ");
            // getParkingList(selectTransport?.id || "");
            onCloseModal();
          } else {
            message.error(`สร้างไม่สำเร็จ: ${res.error_message}`);
          }
        },
        onError: (error) => {
          message.error(`สร้างไม่สำเร็จ: ${error.message}`);
        },
      }
    );
  };

  return (
    <div>
      <div
        style={{
          marginBottom: 10,
          flexDirection: "row",
          alignItems: "center",
          paddingRight: 10,
          borderBottom: "1px solid #f0f0f0",
          paddingBottom: 10,
        }}
      >
        <Form.Item
          label="เลือกจังหวัด"
          className="form-transport"
          name="province_address_id"
        >
          <Select
            allowClear
            placeholder="เลือกจังหวัด"
            filterOption={filterOption}
            showSearch
            onSelect={(value, option) => {
              setProvinceIdAddress(value);
              setDistrictIdAddress(0);
              // setProvinceIdstart(value);
              formTransport.setFieldsValue({
                district_address_id: undefined,
                parking_id: undefined,
              });

              setSelectParkingBefore(undefined);

              // ส่ง name ได้โดยการดึงจาก option
              console.log("Selected province name:", option.name);
              formTransport.setFieldsValue({
                province_name_th: option.name,
              });
            }}
          >
            {childrenProviceStart}
          </Select>
        </Form.Item>
        <Form.Item name="province_name_th" style={{ display: "none" }}>
          <Input readOnly />
        </Form.Item>
        <Form.Item
          label="เลือกอำเภอ"
          className="form-transport"
          name="district_address_id"
          // required
          // rules={[
          //   {
          //     required: true,
          //     message: "กรุณาเลือกอำเภอ",
          //   },
          // ]}
        >
          <Select
            allowClear
            placeholder="เลือกอำเภอ"
            onSelect={(value, option) => {
              setDistrictIdAddress(value);
              formTransport.setFieldsValue({
                parking_id: undefined,
              });

              formTransport.setFieldsValue({
                district_name_th: option.name,
              });
              setSelectParkingBefore(undefined);
            }}
            showSearch
            filterOption={filterOption}
          >
            {masterDistrictDataAddress?.map((item) => (
              <Option key={item.id} value={item.id} name={item.name_th}>
                {item.name_th}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="district_name_th" style={{ display: "none" }}>
          <Input readOnly />
        </Form.Item>
        <Form.Item
          label="จุดส่งสินค้า"
          name="parking_id"
          required
          rules={[
            {
              required: true,
              message: "กรุณาเลือกจุดส่งสินค้า",
            },
          ]}
        >
          <Select
            disabled={districtIdAddress === 0}
            showSearch
            placeholder="จุดส่งสินค้า"
            optionFilterProp="children"
            dropdownRender={(menu) => (
              <>
                {menu}
                <div style={{ marginTop: 10 }}>
                  <Button
                    style={{ width: "100%" }}
                    type="text"
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setShowParking(true);
                    }}
                  >
                    เพิ่มจุดจอด
                  </Button>
                </div>
              </>
            )}
            onSelect={(value, option) => {
              console.log("Selected parking name:", option);
              formTransport.setFieldsValue({
                delivery_name: option.children,
              });

              let parkingSelect = deliveryPointList.find(
                (item) => item.id === value
              );

              console.log("Selected parking:", parkingSelect);

              setSelectParkingBefore(parkingSelect);
            }}
          >
            {childrenParking}
          </Select>
        </Form.Item>
        <Form.Item name="delivery_name" style={{ display: "none" }}>
          <Input readOnly />
        </Form.Item>

        <Form.List name="timeList">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <div
                  key={key}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    // marginBottom: 8,
                    alignItems: "baseline",
                  }}
                >
                  <Form.Item
                    {...restField}
                    name={[name, "time"]}
                    rules={[{ 
                      required: true, 
                      message: "กรุณากรอกเวลาถึง",
                    }, {
                      validator(rule, value, callback) {
                       //ห้าเลือกเวลาซ้ำกัน
                        if (fields.length > 1) {
                          const timeList = formTransport.getFieldValue("timeList");
                          const timeListValue = timeList.map((item: any) => item.time);
                          const timeListValueFilter = timeListValue.filter((item: any) => item !== undefined);
                          const timeListValueFilterString = timeListValueFilter.map((item: any) => item.format("HH:mm"));
                          const timeListValueFilterStringSet = new Set(timeListValueFilterString);
                          if (timeListValueFilterString.length !== timeListValueFilterStringSet.size) {
                            return Promise.reject("เวลาถึงไม่สามารถซ้ำกันได้");
                          }
                        }
                        return Promise.resolve();
                      },

                    }]}
                    label="เวลาถึงโดยประมาณ"
                    style={{ width: "90%" }}
                  >
                    <TimePicker
                      size="middle"
                      format={"HH:mm"}
                      style={{ width: "100%" }}
                      placeholder="เลือกเวลารถถึงจุดจอด"
                    />
                  </Form.Item>

                  <MinusCircleOutlined onClick={() => remove(name)} />
                </div>
              ))}
              <Form.Item wrapperCol={{ span: 24 }} labelAlign="right">
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                    style={{ width: "50%" }}
                  >
                    เพิ่มเวลา
                  </Button>
                </div>
              </Form.Item>
            </>
          )}
        </Form.List>
      </div>

      <Modal
        title="เพิ่มจุดจอด"
        open={showParking}
        maskClosable={false}
        onCancel={() => {
          onCloseModal();
        }}
        // onOk={() => form.submit()}
        style={{ top: 20 }}
        footer={[
          <Button key="back" onClick={() => onCloseModal()}>
            ยกเลิก
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => formModal.submit()}
          >
            บันทึก
          </Button>,
        ]}
      >
        <WrapperAll>
          <Form form={formModal} onFinish={onFinishModal}>
            <DescriptionForm form={formModal} />
          </Form>
        </WrapperAll>
      </Modal>
    </div>
  );
};

export default TransportSeleect;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;
